import { createSlice } from 'utils/@reduxjs/toolkit'
import { useInjectReducer } from 'utils/redux-injectors'
import { IApplicationManagementComponent } from './types'
import { useInjectSaga } from 'redux-injectors'
import { applicationManagementComponentSaga } from './saga'

export const initialState: IApplicationManagementComponent = {
  dates: null,
  agreed: '',
  subscribe: '',
  isLoading: false,
  isLoadingUserData: false,
  registrationFormAsyncErrors: null,
  userData: null
}

const slice = createSlice({
  name: 'applicationManagementComponent',
  initialState,
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload
    },
    setAgreed(state, action) {
      state.agreed = action.payload
    },
    setSubscribe(state, action) {
      state.subscribe = action.payload
    },
    login(state) {
      state.isLoading = true
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    registerUser(state, action) {
      state.isLoading = true
    },
    setRegistrationFormAsyncErrors(state, action) {
      state.registrationFormAsyncErrors = action.payload
    },
    setIsLoadingUserData(state, action) {
      state.isLoadingUserData = action.payload
    },
    setUserData(state, action) {
      state.userData = action.payload
    },
    reset(state) {
      for (const val in initialState) {
        state[val] = initialState[val]
      }
    }
  }
})

export const { actions: applicationManagementComponentActions, reducer } = slice

export const useApplicationManagementComponentSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer })
  useInjectSaga({ key: slice.name, saga: applicationManagementComponentSaga })
  return { actions: slice.actions }
}
